import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import ActiveFacebookPage from '@/plugins/graphql/queries/active-facebook-page.gql';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import ConnectPagePreview from '@/components/v2/preview/ConnectPagePreview.vue';
import CategoryPagePreview from '@/components/v2/preview/ecommerce/CategoryPagePreview.vue';
import DiyStepIndicator from '@/components/v2/DiyStepIndicator';
import ShippingPagePreview from '@/components/v2/preview/ecommerce/ShippingPagePreview.vue';
import PaymentPagePreview from '@/components/v2/preview/ecommerce/PaymentPagePreview.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
import ProductPagePreview from '@/components/v2/preview/ecommerce/ProductPagePreview.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import DiyPreviewDrawerMixin from '@/helpers/vue_mixins/v2/DiyPreviewDrawerMixin';
import LaunchMixin from '@/helpers/vue_mixins/v2/LaunchMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
var Step;
(function (Step) {
    Step[Step["Settings"] = 1] = "Settings";
    // Categories,
    // Products,
    Step[Step["Cart"] = 2] = "Cart";
    Step[Step["Shipping"] = 3] = "Shipping";
    Step[Step["Payment"] = 4] = "Payment";
})(Step || (Step = {}));
let EcommerceB2cBundle = class EcommerceB2cBundle extends Mixins(AppDetailsMixin, ViewportSizeMixin, DiyPreviewDrawerMixin, LaunchMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.step = 1;
    }
    get steps() {
        return [
            {
                name: 'Settings',
                step: Step.Settings,
                show: true,
                previewComponent: ConnectPagePreview,
                component: () => import('@/components/v2/diy/PageSettings.vue'),
            },
        ];
    }
    get lastStep() {
        return Step.Settings;
    }
    onNext() {
        if (this.step === this.lastStep) {
            this.allowNavigation();
            this.navigateToLaunchPage();
        }
        else {
            this.step++;
        }
    }
    onPrevious() {
        this.step -= 1;
    }
    navigateToLaunchPage() {
        this.publishApp(this.appUuid);
    }
    mounted() {
        this.viewDIYPage('Setup In-App Store');
    }
};
__decorate([
    Prop({ type: String, required: true })
], EcommerceB2cBundle.prototype, "pageUuid", void 0);
EcommerceB2cBundle = __decorate([
    Component({
        apollo: {
            activePage: {
                query: ActiveFacebookPage,
                variables() {
                    return {
                        appUUID: this.appUuid,
                    };
                },
                update(data) {
                    return data.activePage;
                },
            },
        },
        components: {
            ActionButton,
            DiyStepIndicator,
            PageTitle,
            CategoryPagePreview,
            ConnectPagePreview,
            ProductPagePreview,
            ShippingPagePreview,
            PaymentPagePreview,
        },
    })
], EcommerceB2cBundle);
export default EcommerceB2cBundle;
